import { StripeMandateModel, IStripeMandate } from "@core/models";

export const stripeMandateMock = new StripeMandateModel({
  [IStripeMandate.clientSecret]: "seti_1XjhXoXoopeIlX3X0kXXbyXn_secret_XXglaXmdXXXjXXpXXwicXXcXxx0zxxX",
});
